import Api from '../api'

export default ({

  state: {
    jobTitleList: [],
    employmentStatusList: [],
    jobCategoryList: [],
    terminationReasonList: [],
    skillList: [],
    educationList: [],
    membershipList: [],
    languageList: [],
    licenseList: [],
    nationalityList: [],
    leaveTypeList: [],
    leavePeriodList: [],
    holidayList: [],
    leaveEntitlementList: [],
    workShiftList: [],
    payGradeList: [],
    employeeList: [],
    employeeDropdownList: [],
    leaveRequestList: [],
    leaveEmployeeRequestList: [],
    attendanceRequestList: [],
    employeePositionLists: [],
    employeePositionSubGroupLists: [],
    employeeGroupLists: [],
    employeeGroupListsDropdown: [],
    employeePositionListsDropdown: [],
    employeePositionListsSubDropdown: [],
    payHeadList: [],
    payHeadDropdownList: [],
    hrSalaryPostingList: [],
    hrEarningSalaryPostingList: [],
    hrDeductionSalaryPostingList: [],
    maxAssignNumber: null,
    employeeInventoryAssignList: [],
    inventoryAssignDetailList: [],
    employeeTransferList: []
  },
  mutations: {
    SET_JOB_TITLE_LIST(state, hrMasterList) {
      state.jobTitleList = hrMasterList
    },
    CREATE_JOB_TITLE(state, jobTitle) {
      let hrMasterSetup = state.jobTitleList.concat(jobTitle)
      state.jobTitleList = hrMasterSetup
    },
    DELETE_JOB_TITLE(state, deleteJobTitle) {
      let jobTitle = state.jobTitleList.filter(a => a.id !== deleteJobTitle.id)
      state.jobTitleList = jobTitle
    },
    UPDATE_JOB_TITLE(state, updateJobTitle) {
      state.jobTitleList = state.jobTitleList.map(jobTitle => jobTitle.id !== updateJobTitle.id ? jobTitle : {...jobTitle, ...updateJobTitle})
    },
    // EMPLOYEE STATUS
    SET_EMPLOYEE_STATUS_LIST(state, hrMasterList) {
      state.employmentStatusList = hrMasterList
    },
    SET_WORKSHIFT_LIST(state, siftList) {
      state.workShiftList = siftList
    },
    CREATE_EMPLOYMENT_STATUS(state, employmentStatus) {
      state.employmentStatusList = state.employmentStatusList.concat(employmentStatus)
    },
    UPDATE_EMPLOYMENT_STATUS(state, updateEmploymentStatus) {
      state.employmentStatusList = state.employmentStatusList.map(employmentStatus => employmentStatus.id !== updateEmploymentStatus.id ? employmentStatus : {...employmentStatus, ...updateEmploymentStatus})
    },
    DELETE_EMPLOYMENT_STATUS(state, deleteEmploymentStatus) {
      state.employmentStatusList = state.employmentStatusList.filter(a => a.id !== deleteEmploymentStatus.id)
    },
    // JOB CATEGORY
    SET_JOB_CATEGORY(state, hrMasterList) {
      state.jobCategoryList = hrMasterList
    },
    CREAT_JOB_CATEGORY(state, jobCategory) {
      state.jobCategoryList = state.jobCategoryList.concat(jobCategory)
    },
    UPDATE_JOB_CATEGORY(state, updateJobCategory) {
      state.jobCategoryList = state.jobCategoryList.map(jobCategory => jobCategory.id !== updateJobCategory.id ? jobCategory : {...jobCategory, ...updateJobCategory})
    },
    DELETE_JOB_CATEGORY(state, deleteJobCategory) {
      state.jobCategoryList = state.jobCategoryList.filter(a => a.id !== deleteJobCategory.id)
    },
    // Termination Reason
    SET_TERMINATION_REASON(state, hrMasterList) {
      state.terminationReasonList = hrMasterList
    },
    CREATE_TERMINATION_REASON(state, terminationReason) {
      state.terminationReasonList = state.terminationReasonList.concat(terminationReason)
    },
    UPDATE_TERMINATION_REASON(state, updateTermination) {
      state.terminationReasonList = state.terminationReasonList.map(termination => termination.id !== updateTermination.id ? termination : {...termination, ...updateTermination})
    },
    DELETE_TERMINATION_REASON(state, deleteTermination) {
      state.terminationReasonList = state.terminationReasonList.filter(a => a.id !== deleteTermination.id)
    },
    SET_EDUCATION_LIST(state, hrMasterList) {
      state.educationList = hrMasterList
    },
    CREATE_EDUCATION(state, education) {
      state.educationList = state.terminationReasonList.concat(education)
    },
    CREATE_WORK_SHIFT(state, workShift) {
      state.workShiftList = state.workShiftList.concat(workShift)
    },
    UPDATE_WORK_SHIFT(state, updateworkShift) {
      state.workShiftList = state.workShiftList.map(work => work.id !== updateworkShift.id ? work : {...work, ...updateworkShift})
    },
    DELETE_WORK_SHIFT(state, deleteworkShift) {
      state.workShiftList = state.workShiftList.filter(a => a.id !== deleteworkShift.id)
    },
    DELETE_EDUCATION(state, deleteEducation) {
      state.educationList = state.educationList.filter(a => a.id !== deleteEducation.id)
    },
    UPDATE_EDUCATION(state, updateEducation) {
      state.educationList = state.educationList.map(education => education.id !== updateEducation.id ? education : {...education, ...updateEducation})
    },
    SET_SKILL_LIST(state, hrMasterList) {
      state.skillList = hrMasterList
    },
    CREATE_SKILL(state, skill) {
      state.skillList = state.skillList.concat(skill)
    },
    DELETE_SKILL(state, deleteSkill) {
      state.skillList = state.skillList.filter(a => a.id !== deleteSkill.id)
    },
    UPDATE_SKILL(state, updateSkill) {
      state.skillList = state.skillList.map(skill => skill.id !== updateSkill.id ? skill : {...skill, ...updateSkill})
    },
    SET_LANGUAGE_LIST(state, hrMasterList) {
      state.languageList = hrMasterList
    },
    CREATE_LANGUAGE(state, language) {
      state.languageList = state.languageList.concat(language)
    },
    DELETE_LANGUAGE(state, deleteLanguage) {
      state.languageList = state.languageList.filter(a => a.id !== deleteLanguage.id)
    },
    UPDATE_LANGUAGE(state, updateLanguage) {
      state.languageList = state.languageList.map(language => language.id !== updateLanguage.id ? language : {...language, ...updateLanguage})
    },
    SET_MEMBERSHIP_LIST(state, hrMasterList) {
      state.membershipList = hrMasterList
    },
    CREATE_MEMBERSHIP(state, membership) {
      state.membershipList = state.membershipList.concat(membership)
    },
    DELETE_MEMBERSHIP(state, deleteMembership) {
      state.membershipList = state.membershipList.filter(a => a.id !== deleteMembership.id)
    },
    UPDATE_MEMBERSHIP(state, updateMembership) {
      state.membershipList = state.membershipList.map(membership => membership.id !== updateMembership.id ? membership : {...membership, ...updateMembership})
    },
    SET_NATIONALITY_LIST(state, hrMasterList) {
      state.nationalityList = hrMasterList
    },
    CREATE_NATIONALITY(state, nationality) {
      state.nationalityList = state.nationalityList.concat(nationality)
    },
    DELETE_NATIONALITY(state, deleteNationality) {
      state.nationalityList = state.nationalityList.filter(a => a.id !== deleteNationality.id)
    },
    UPDATE_NATIONALITY(state, updateNationality) {
      state.nationalityList = state.nationalityList.map(nationality => nationality.id !== updateNationality.id ? nationality : {...nationality, ...updateNationality})
    },
    SET_LICENSE_LIST(state, hrMasterList) {
      state.licenseList = hrMasterList
    },
    CREATE_LICENSE(state, license) {
      state.licenseList = state.licenseList.concat(license)
    },
    DELETE_LICENSE(state, deleteLicense) {
      state.licenseList = state.licenseList.filter(a => a.id !== deleteLicense.id)
    },
    UPDATE_LICENSE(state, updateLicense) {
      state.licenseList = state.licenseList.map(license => license.id !== updateLicense.id ? license : {...license, ...updateLicense})
    },
    // Leave Mutation
    SET_LEAVETYPE_LIST(state, hrMasterList) {
      state.leaveTypeList = hrMasterList
    },
    CREATE_LEAVETYPE(state, leaveType) {
      state.leaveTypeList = state.leaveTypeList.concat(leaveType)
    },
    DELETE_LEAVETYPE(state, leaveType) {
      state.leaveTypeList = state.leaveTypeList.filter(a => a.id !== leaveType.id)
    },
    UPDATE_LEAVETYPE(state, updateLeaveType) {
      state.leaveTypeList = state.leaveTypeList.map(leaveType => leaveType.id !== updateLeaveType.id ? leaveType : {...leaveType, ...updateLeaveType})
    },
    SET_LEAVE_PERIOD_LIST(state, periodList) {
      state.leavePeriodList = periodList
    },
    CREATE_LEAVE_PERIOD(state, period) {
      state.leavePeriodList = state.leavePeriodList.concat(period)
    },
    DELETE_LEAVE_PERIOD(state, period) {
      state.leavePeriodList = state.leavePeriodList.filter(a => a.id !== period.id)
    },
    UPDATE_LEAVE_PERIOD(state, updatePeriod) {
      state.leavePeriodList = state.leavePeriodList.map(period => period.id !== updatePeriod.id ? period : {...period, ...updatePeriod})
    },
    SET_HOLIDAY_LIST(state, holidayL) {
      state.holidayList = holidayL
    },
    CREATE_HOLIDAY(state, holiday) {
      state.holidayList = state.holidayList.concat(holiday)
    },
    DELETE_HOLIDAY(state, holiday) {
      state.holidayList = state.holidayList.filter(a => a.id !== holiday.id)
    },
    UPDATE_HOLIDAY(state, updateHoliday) {
      state.holidayList = state.holidayList.map(holiday => holiday.id !== updateHoliday.id ? holiday : {...holiday, ...updateHoliday})
    },
    SET_LEAVE_ENTITLEMENT_LIST(state, leaveEntitlement) {
      state.leaveEntitlementList = leaveEntitlement
    },
    CREATE_LEAVE_ENTITLEMENT(state, leaveEntitlement) {
      state.leaveEntitlementList = state.leaveEntitlementList.concat(leaveEntitlement)
    },
    DELETE_LEAVE_ENTITLEMENT(state, leaveEntitlement) {
      state.leaveEntitlementList = state.leaveEntitlementList.filter(a => a.id !== leaveEntitlement.id)
    },
    UPDATE_LEAVE_ENTITLEMENT(state, updateLeaveEntitlement) {
      state.leaveEntitlementList = state.leaveEntitlementList.map(entitlement => entitlement.id !== updateLeaveEntitlement.id ? entitlement : {...entitlement, ...updateLeaveEntitlement})
    },
    SET_PAY_GRADE_LIST(state, payGrade) {
      state.payGradeList = payGrade
    },
    CREATE_PAY_GRADE(state, payGrade) {
      state.payGradeList = state.payGradeList.concat(payGrade)
    },
    DELETE_PAY_GRADE(state, payGrade) {
      state.payGradeList = state.payGradeList.filter(a => a.id !== payGrade.id)
    },
    UPDATE_PAY_GRADE(state, updatePayGrade) {
      state.payGradeList = state.payGradeList.map(payGrade => payGrade.id !== updatePayGrade.id ? payGrade : {...payGrade, ...updatePayGrade})
    },
    SET_EMPLOYEE_LIST(state, employee) {
      state.employeeList = employee
    },
    SET_EMPLOYEE_DROPDOWN_LIST(state, employee) {
      state.employeeDropdownList = employee
    },
    CREATE_EMPLOYEE(state, employee) {
      state.employeeList = state.employeeList.concat(employee)
    },
    DELETE_EMPLOYEE(state, employee) {
      state.employeeList = state.employeeList.filter(a => a.id !== employee.id)
    },
    UPDATE_EMPLOYEE(state, updateEmployee) {
      state.employeeList = state.employeeList.map(employee => employee.id !== updateEmployee.id ? employee : {...employee, ...updateEmployee})
    },
    SET_LEAVE_REQUEST_LIST(state, leave) {
      state.leaveRequestList = leave
    },
    SET_EMPLOYEE_LEAVE_REQUEST_LIST(state, leave) {
      state.leaveEmployeeRequestList = leave
    },
    CREATE_EMPLOYEE_LEAVE_REQUEST(state, leave) {
      state.leaveEmployeeRequestList = state.leaveEmployeeRequestList.concat(leave)
    },
    DELETE_EMPLOYEE_LEAVE_REQUEST(state, leave) {
      state.leaveEmployeeRequestList = state.leaveEmployeeRequestList.filter(a => a.id !== leave.id)
    },
    UPDATE_EMPLOYEE_LEAVE_REQUEST(state, updateLeave) {
      state.leaveEmployeeRequestList = state.leaveEmployeeRequestList.map(leave => leave.id !== updateLeave.id ? leave : {...leave, ...updateLeave})
    },
    SET_ATTENDANCE_REQUEST(state, attendance) {
      state.attendanceRequestList = attendance
    },
    CREATE_ATTENDANCE_REQUEST(state, attendance) {
      state.attendanceRequestList = state.attendanceRequestList.concat(attendance)
    },
    DELETE_ATTENDANCE_REQUEST(state, attendance) {
      state.attendanceRequestList = state.attendanceRequestList.filter(a => a.id !== attendance.id)
    },
    UPDATE_ATTENDANCE_REQUEST(state, updateAttendance) {
      state.attendanceRequestList = state.attendanceRequestList.map(attendance => attendance.id !== updateAttendance.id ? attendance : {...attendance, ...updateAttendance})
    },
    SET_EMPLOYEE_GROUP(state, group) {
      state.employeeGroupLists = group
    },
    SET_EMPLOYEE_GROUP_DROPDOWN(state, group) {
      state.employeeGroupListsDropdown = group
    },
    SET_EMPLOYEE_POSITION_DROPDOWN(state, group) {
      state.employeePositionListsDropdown = group
    },
    SET_EMPLOYEE_POSITION_SUBGROUP_DROPDOWN(state, subGroup) {
      state.employeePositionListsSubDropdown = subGroup
    },
    CREATE_EMPLOYEE_GROUP(state, group) {
      state.employeeGroupLists = state.employeeGroupLists.concat(group)
    },
    DELETE_EMPLOYEE_GROUP(state, group) {
      state.employeeGroupLists = state.employeeGroupLists.filter(a => a.id !== group.id)
    },
    UPDATE_EMPLOYEE_GROUP(state, updateGroup) {
      state.employeeGroupLists = state.employeeGroupLists.map(group => group.id !== updateGroup.id ? group : {...group, ...updateGroup})
    },
    SET_EMPLOYEE_POSITION(state, group) {
      state.employeePositionLists = group
    },
    SET_EMPLOYEE_POSITION_SUBGROUP(state, group) {
      state.employeePositionSubGroupLists = group
    },
    CREATE_EMPLOYEE_POSITION(state, group) {
      state.employeePositionLists = state.employeePositionLists.concat(group)
    },
    CREATE_EMPLOYEE_POSITION_SUBGROUP(state, group) {
      state.employeePositionSubGroupLists = state.employeePositionSubGroupLists.concat(group)
    },
    DELETE_EMPLOYEE_POSITION(state, group) {
      state.employeePositionLists = state.employeePositionLists.filter(a => a.id !== group.id)
    },
    DELETE_EMPLOYEE_POSITION_SUBGROUP(state, group) {
      state.employeePositionSubGroupLists = state.employeePositionSubGroupLists.filter(a => a.id !== group.id)
    },
    UPDATE_EMPLOYEE_POSITION(state, updateGroup) {
      state.employeePositionLists = state.employeePositionLists.map(group => group.id !== updateGroup.id ? group : {...group, ...updateGroup})
    },
    SET_PAYHEAD(state, group) {
      state.payHeadList = group
    },
    SET_DROPDOWN_PAYHEAD(state, group) {
      state.payHeadDropdownList = group
    },
    CREATE_PAYHEAD(state, group) {
      state.payHeadList = state.payHeadList.concat(group)
    },
    DELETE_PAYHEAD(state, group) {
      state.payHeadList = state.payHeadList.filter(a => a.id !== group.id)
    },
    UPDATE_PAYHEAD(state, updateGroup) {
      state.payHeadList = state.payHeadList.map(group => group.id !== updateGroup.id ? group : {...group, ...updateGroup})
    },
    LOAD_HRMASTER_SALARY_POSTING(state, hrSalaryPosting) {
      state.hrSalaryPostingList = hrSalaryPosting
    },
    LOAD_BY_SALARY_TYPE(state, hrSalaryByType) {
      if (hrSalaryByType.type === 'Earning') {
        state.hrEarningSalaryPostingList = hrSalaryByType.response
      } else {
        state.hrDeductionSalaryPostingList = hrSalaryByType.response
      }
    },
    MAX_ASSIGN_NUMBER(state, maxAssignNo) {
      state.maxAssignNumber = maxAssignNo
    },
    DELETE_EMPLOYEE_ASSIGN(state, group) {
      state.employeeInventoryAssignList = state.employeeInventoryAssignList.filter(a => a.id !== group.id)
    },
    LOAD_EMPLOYEE_ASSIGN_LIST(state, employeeInventoryAssign) {
      state.employeeInventoryAssignList = employeeInventoryAssign
    },
    INVENTORY_ASSIGN_DETAIL(state, inventoryInDetail) {
      state.inventoryAssignDetailList = inventoryInDetail
    },
    // EMployee Transfer
    EMPLOYEE_TRANSFER_LIST(state, empyTransfer) {
      state.employeeTransferList = empyTransfer
    },
    ADD_EMPLOYEE_TRANSFER(state, employeeTransfer) {
      state.employeeTransferList = state.employeeTransferList.concat(employeeTransfer)
    }
  },
  actions: {
    async loadHrMasterSetupList({commit}, type) {
      let response = await Api.request('get', '/hrMaster/loadHrMasterSetupList/' + this.state.organisationid + '/' + type)
      if (response.data.status === 'SUCCESS') {
        switch (type) {
          case 'JobTitle':
            commit('SET_JOB_TITLE_LIST', response.data.data)
            break
          case 'EmployeeStatus':
            commit('SET_EMPLOYEE_STATUS_LIST', response.data.data)
            break
          case 'JobCategory':
            commit('SET_JOB_CATEGORY', response.data.data)
            break
          case 'TerminationReason':
            commit('SET_TERMINATION_REASON', response.data.data)
            break
          case 'Education':
            commit('SET_EDUCATION_LIST', response.data.data)
            break
          case 'Skill':
            commit('SET_SKILL_LIST', response.data.data)
            break
          case 'License':
            commit('SET_LICENSE_LIST', response.data.data)
            break
          case 'Language':
            commit('SET_LANGUAGE_LIST', response.data.data)
            break
          case 'Membership':
            commit('SET_MEMBERSHIP_LIST', response.data.data)
            break
          case 'Nationality':
            commit('SET_NATIONALITY_LIST', response.data.data)
            break
          case 'LeaveType':
            commit('SET_LEAVETYPE_LIST', response.data.data)
            break
          case 'EmployeeGroup':
            commit('SET_EMPLOYEE_GROUP', response.data.data)
            break
          case 'EmployeePosition':
            commit('SET_EMPLOYEE_POSITION', response.data.data)
            break
          case 'EmployeePositionSubGroup':
            commit('SET_EMPLOYEE_POSITION_SUBGROUP', response.data.data)
            break
        }
      }
    },
    async createHrMasterSetup({commit}, jobTitle) {
      let response = await Api.request('post', '/hrMaster/hrMasterSetupByType/' + this.state.organisationid + '/' + this.state.user.id, jobTitle)
      if (response.data.status === 'SUCCESS') {
        switch (jobTitle.type) {
          case 'JobTitle':
            commit('CREATE_JOB_TITLE', response.data.data)
            break
          case 'EmployeeStatus':
            commit('CREATE_EMPLOYMENT_STATUS', response.data.data)
            break
          case 'JobCategory':
            commit('CREAT_JOB_CATEGORY', response.data.data)
            break
          case 'TerminationReason':
            commit('CREATE_TERMINATION_REASON', response.data.data)
            break
          case 'Education':
            commit('CREATE_EDUCATION', response.data.data)
            break
          case 'Skill':
            commit('CREATE_SKILL', response.data.data)
            break
          case 'License':
            commit('CREATE_LICENSE', response.data.data)
            break
          case 'Language':
            commit('CREATE_LANGUAGE', response.data.data)
            break
          case 'Membership':
            commit('CREATE_MEMBERSHIP', response.data.data)
            break
          case 'Nationality':
            commit('CREATE_NATIONALITY', response.data.data)
            break
          case 'LeaveType':
            commit('CREATE_LEAVETYPE', response.data.data)
            break
          case 'EmployeeGroup':
            commit('CREATE_EMPLOYEE_GROUP', response.data.data)
            break
          case 'EmployeePosition':
            commit('CREATE_EMPLOYEE_POSITION', response.data.data)
            break
          case 'EmployeePositionSubGroup':
            commit('CREATE_EMPLOYEE_POSITION_SUBGROUP', response.data.data)
            break
        }
      }
      return response
    },
    async deleteHrMasterSetup({commit}, jobTitle) {
      let response = await Api.request('delete', '/hrMaster/deleteHrMasterSetup/' + jobTitle.id + '/' + this.state.user.id + '/' + jobTitle.deleteReason)
      if (response.data.status === 'SUCCESS') {
        switch (jobTitle.type) {
          case 'JobTitle':
            commit('DELETE_JOB_TITLE', response.data.data)
            break
          case 'EmployeeStatus':
            commit('DELETE_EMPLOYMENT_STATUS', response.data.data)
            break
          case 'JobCategory':
            commit('DELETE_JOB_CATEGORY', response.data.data)
            break
          case 'TerminationReason':
            commit('DELETE_TERMINATION_REASON', response.data.data)
            break
          case 'Education':
            commit('DELETE_EDUCATION', response.data.data)
            break
          case 'Skill':
            commit('DELETE_SKILL', response.data.data)
            break
          case 'License':
            commit('DELETE_LICENSE', response.data.data)
            break
          case 'Language':
            commit('DELETE_LANGUAGE', response.data.data)
            break
          case 'Membership':
            commit('DELETE_MEMBERSHIP', response.data.data)
            break
          case 'Nationality':
            commit('DELETE_NATIONALITY', response.data.data)
            break
          case 'LeaveType':
            commit('DELETE_LEAVETYPE', response.data.data)
            break
          case 'EmployeeGroup':
            commit('DELETE_EMPLOYEE_GROUP', response.data.data)
            break
          case 'EmployeePosition':
            commit('DELETE_EMPLOYEE_POSITION', response.data.data)
            break
          case 'EmployeePositionSubGroup':
            commit('DELETE_EMPLOYEE_POSITION_SUBGROUP', response.data.data)
            break
        }
      }
      return response
    },
    async updateHrMasterSetup({commit}, updateJobTitle) {
      let response = await Api.request('put', '/hrMaster/updateHrMasterSetup/' + updateJobTitle.id + '/' + this.state.user.id, updateJobTitle)
      if (response.data.status === 'SUCCESS') {
        switch (updateJobTitle.type) {
          case 'JobTitle':
            commit('UPDATE_JOB_TITLE', response.data.data)
            break
          case 'EmployeeStatus':
            commit('UPDATE_EMPLOYMENT_STATUS', response.data.data)
            break
          case 'JobCategory':
            commit('UPDATE_JOB_CATEGORY', response.data.data)
            break
          case 'TerminationReason':
            commit('UPDATE_TERMINATION_REASON', response.data.data)
            break
          case 'Education':
            commit('UPDATE_EDUCATION', response.data.data)
            break
          case 'Skill':
            commit('UPDATE_SKILL', response.data.data)
            break
          case 'License':
            commit('UPDATE_LICENSE', response.data.data)
            break
          case 'Language':
            commit('UPDATE_LANGUAGE', response.data.data)
            break
          case 'Membership':
            commit('UPDATE_MEMBERSHIP', response.data.data)
            break
          case 'Nationality':
            commit('UPDATE_NATIONALITY', response.data.data)
            break
          case 'LeaveType':
            commit('UPDATE_LEAVETYPE', response.data.data)
            break
          case 'EmployeeGroup':
            commit('UPDATE_EMPLOYEE_GROUP', response.data.data)
            break
          case 'EmployeePosition':
            commit('UPDATE_EMPLOYEE_POSITION', response.data.data)
            break
          case 'EmployeePositionSubGroup':
            commit('UPDATE_EMPLOYEE_POSITION_SUBGROUP', response.data.data)
            break
        }
      }
      return response
    },
    async loadWorkShiftList({commit}) {
      let response = await Api.request('get', '/workShift/loadHrWorkShiftList/' + this.state.organisationid, null)
      commit('SET_WORKSHIFT_LIST', response.data.data)
    },
    async createWorkShift({commit}, workShift) {
      let response = await Api.request('post', '/workShift/createHrWorkShift/' + this.state.organisationid + '/' + this.getters.userId, workShift)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_WORK_SHIFT', response.data.data)
      }
      return response
    },
    async deleteWorkShift({commit}, deleteRea) {
      let response = await Api.request('delete', '/workShift/deleteHrWorkShift/' + deleteRea.workShiftId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let workShiftList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_WORK_SHIFT', workShiftList)
      }
      return response
    },
    async updateWorkShift({commit}, workShiftId) {
      let resp = await Api.request('put', '/workShift/updateHrWorkShift/' + workShiftId.id, workShiftId)
      commit('UPDATE_WORK_SHIFT', resp.data.data)
      return resp
    },
    async loadLeavePeriodList({commit}) {
      let response = await Api.request('get', '/hrMaster/loadHrLeavePeriodList/' + this.state.organisationid, null)
      commit('SET_LEAVE_PERIOD_LIST', response.data.data)
    },
    async createLeavePeriod({commit}, leave) {
      let response = await Api.request('post', '/hrMaster/createLeavePeriod/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_LEAVE_PERIOD', response.data.data)
      }
      return response
    },
    async deleteLeavePeriod({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrMaster/deleterLeavePeriod/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let leavePeriodList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_LEAVE_PERIOD', leavePeriodList)
      }
      return response
    },
    async updateLeavePeriod({commit}, leave) {
      let resp = await Api.request('put', '/hrMaster/updateLeavePeriod/' + leave.id, leave)
      commit('UPDATE_LEAVE_PERIOD', resp.data.data)
      return resp
    },
    async loadHolidayList({commit}) {
      let response = await Api.request('get', '/hrLeaveHoliday/loadHolidayList/' + this.state.organisationid, null)
      commit('SET_HOLIDAY_LIST', response.data.data)
    },
    async createHoliday({commit}, leave) {
      let response = await Api.request('post', '/hrLeaveHoliday/createHoliday/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_HOLIDAY', response.data.data)
      }
      return response
    },
    async deleteHoliday({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrLeaveHoliday/deleteHoliday/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let holidayList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_HOLIDAY', holidayList)
      }
      return response
    },
    async updateHoliday({commit}, leave) {
      let resp = await Api.request('put', '/hrLeaveHoliday/updateHoliday/' + leave.id, leave)
      commit('UPDATE_HOLIDAY', resp.data.data)
      return resp
    },
    async loadLeaveEntitlementList({commit}) {
      let response = await Api.request('get', '/hrLeaveHoliday/loadLeaveEntitlementList/' + this.state.organisationid, null)
      commit('SET_HOLIDAY_LIST', response.data.data)
    },
    async createLeaveEntitlement({commit}, leave) {
      let response = await Api.request('post', '/hrLeaveHoliday/createLeaveEntitlement/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_HOLIDAY', response.data.data)
      }
      return response
    },
    async deleteLeaveEntitlement({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrLeaveHoliday/deleteLeaveEntitlement/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let holidayList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_HOLIDAY', holidayList)
      }
      return response
    },
    async updateLeaveEntitlement({commit}, leave) {
      let resp = await Api.request('put', '/hrLeaveHoliday/updateLeaveEntitlement/' + leave.id, leave)
      commit('UPDATE_HOLIDAY', resp.data.data)
      return resp
    },
    async loadPayGradeList({commit}) {
      let response = await Api.request('get', '/hrMaster/loadHrPayGradeList/' + this.state.organisationid, null)
      commit('SET_PAY_GRADE_LIST', response.data.data)
    },
    async createPayGrade({commit}, leave) {
      let response = await Api.request('post', '/hrMaster/createPayGrade/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_PAY_GRADE', response.data.data)
      }
      return response
    },
    async deletePayGrade({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrMaster/deleteHrPayGrade/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let holidayList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_PAY_GRADE', holidayList)
      }
      return response
    },
    async updatePayGrade({commit}, leave) {
      let resp = await Api.request('put', '/hrMaster/updateHrPayGrade/' + leave.id + '/' + this.getters.userId, leave)
      commit('UPDATE_PAY_GRADE', resp.data.data)
      return resp
    },
    async loadEmployeeList({commit}) {
      let response = await Api.request('get', '/hrEmployee/loadHrEmployeeMasterList/' + this.state.organisationid, null)
      commit('SET_EMPLOYEE_LIST', response.data.data)
      return response
    },
    async loadEmployeeDropdownList({commit}) {
      let response = await Api.request('get', '/hrEmployee/loadHrEmployeeDropdownList/' + this.state.organisationid, null)
      commit('SET_EMPLOYEE_DROPDOWN_LIST', response.data.data)
    },
    // async createEmployee({commit}, leave) {
    //   let response = await Api.request('post', '/hrEmployee/createEmployee/' + this.state.organisationid + '/' + this.getters.userId, leave)
    //   if (response.data.status === 'SUCCESS') {
    //     commit('CREATE_EMPLOYEE', response.data.data)
    //   }
    //   return response
    // },
    async createEmployee({commit}, employee) {
      let response = await Api.request('post', '/hrEmployee/createEmployee/' + this.state.organisationid + '/' + this.state.user.id, employee)
      let savedItemMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_EMPLOYEE', savedItemMaster)
      }
      return response
    },
    async updateEmployee({commit}, epmloyee) {
      let resp = await Api.request('put', '/hrEmployee/updateEmployee/' + this.state.organisationid + '/' + this.state.user.id, epmloyee)
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_EMPLOYEE', resp.data.data)
      }
      return resp
    },
    async deleteEmployee({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrEmployee/deleteEmployee/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let holidayList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_EMPLOYEE', holidayList)
      }
      return response
    },
    // async updateEmployee({commit}, leave) {
    //   let resp = await Api.request('put', '/hrEmployee/updateEmployee/' + leave.id, leave)
    //   commit('UPDATE_EMPLOYEE', resp.data.data)
    //   return resp
    // },
    async loadLeaveRequestList({commit}) {
      let response = await Api.request('get', '/hrLeaveHoliday/loadAbsenceRequestList/' + this.state.organisationid, null)
      commit('SET_LEAVE_REQUEST_LIST', response.data.data)
    },
    async loadLeaveRequestByEmployeeList({commit}) {
      let response = await Api.request('get', '/hrLeaveHoliday/loadAbsenceRequestByEmployeeIdList/' + this.state.organisationid + '/' + this.getters.userId, null)
      commit('SET_EMPLOYEE_LEAVE_REQUEST_LIST', response.data.data)
    },
    async createLeaveRequest({commit}, leave) {
      let response = await Api.request('post', '/hrLeaveHoliday/createAbsenceRequest/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_EMPLOYEE_LEAVE_REQUEST', response.data.data)
      }
      return response
    },
    async deleteLeaveRequest({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrLeaveHoliday/deleteAbsenceRequest/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let holidayList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_EMPLOYEE_LEAVE_REQUEST', holidayList)
      }
      return response
    },
    async updateLeaveRequest({commit}, leave) {
      let resp = await Api.request('put', '/hrLeaveHoliday/updateAbsenceRequest/' + leave.id, leave)
      commit('UPDATE_EMPLOYEE_LEAVE_REQUEST', resp.data.data)
      return resp
    },
    async maxAssignNo({commit}) {
      let response = await Api.request('get', '/hrInventoryAssign/assignLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      // // debugger
      commit('MAX_ASSIGN_NUMBER', responseValue)
      return response
    },
    async loadAttandanceList({commit}) {
      let response = await Api.request('get', '/hrLeaveHoliday/loadAttendanceRequestList/' + this.state.organisationid, null)
      commit('SET_ATTENDANCE_REQUEST', response.data.data)
    },
    async createAttendanceRequest({commit}, leave) {
      let response = await Api.request('post', '/hrLeaveHoliday/createAttendanceRequest/' + this.state.organisationid + '/' + this.getters.userId, leave)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_ATTENDANCE_REQUEST', response.data.data)
      }
      return response
    },
    async deleteAttendanceRequest({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrLeaveHoliday/deleteAttendanceRequest/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let attendanceRequestList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ATTENDANCE_REQUEST', attendanceRequestList)
      }
      return response
    },
    async updateAttendanceRequest({commit}, leave) {
      let resp = await Api.request('put', '/hrLeaveHoliday/updateAttendanceRequest/' + leave.id, leave)
      commit('UPDATE_ATTENDANCE_REQUEST', resp.data.data)
      return resp
    },
    async loadHrPayHeadList({commit}) {
      let response = await Api.request('get', '/hrMaster/loadHrPayHeadList/' + this.state.organisationid, null)
      commit('SET_PAYHEAD', response.data.data)
      return response.data.data
    },
    async loadHrPayHeadDropDownList({commit}) {
      let response = await Api.request('get', '/hrMaster/loadHrPayHeadDropdownList/' + this.state.organisationid, null)
      commit('SET_DROPDOWN_PAYHEAD', response.data.data)
      return response.data.data
    },
    async createHrPayHead({commit}, payHead) {
      let response = await Api.request('post', '/hrMaster/createPayHead/' + this.state.organisationid + '/' + this.getters.userId, payHead)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_PAYHEAD', response.data.data)
      }
      return response
    },
    async deleteHrPayHead({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrMaster/deleteHrPayHead/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let attendanceRequestList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_PAYHEAD', attendanceRequestList)
      }
      return response
    },
    async updateHrPayHead({commit}, payHead) {
      let resp = await Api.request('put', '/hrMaster/updateHrPayHead/' + payHead.id + '/' + this.state.user.id, payHead)
      commit('UPDATE_PAYHEAD', resp.data.data)
      // // debugger
      return resp
    },
    async loadHrMasterSalaryPostingList({commit}, employeeId) {
      let resp = await Api.request('get', '/hrSalaryPosting/loadHrMasterSalaryPostingList/' + this.getters.organisationId + '/' + this.getters.userId + '/' + employeeId)
      commit('LOAD_HRMASTER_SALARY_POSTING', resp.data.data)
      return resp
    },
    async loadAllEmployeeHrMasterSalaryPostingList({commit}) {
      let resp = await Api.request('get', '/hrSalaryPosting/loadAllEmployeeHrMasterSalaryPostingList/' + this.getters.organisationId + '/' + this.getters.userId)
      commit('LOAD_HRMASTER_SALARY_POSTING', resp.data.data)
      return resp
    },
    async loadHrPayHeadListByType({commit}, type) {
      let resp = await Api.request('get', '/hrMaster/loadHrPayHeadListByType/' + this.getters.organisationId + '/' + type)
      let response = {
        response: resp.data.data,
        type: type
      }
      commit('LOAD_BY_SALARY_TYPE', response)
      return resp
    },
    // async loadHrPayHeadListByType({commit}, type) {
    //   let resp = await Api.request('get', '/hrMaster/loadHrPayHeadListByType/' + this.getters.organisationId + '/' + type)
    //   let response = {
    //     response: resp.data.data,
    //     type: type
    //   }
    //   commit('LOAD_BY_SALARY_TYPE', response)
    //   return resp
    // },
    async loadHrMasterForDropdownList({commit}, type) {
      let response = await Api.request('get', '/hrMaster/loadHrMasterSetupListForDropDown/' + this.state.organisationid + '/' + type)
      switch (type) {
        case 'EmployeeGroup':
          commit('SET_EMPLOYEE_GROUP_DROPDOWN', response.data.data)
          break
        case 'EmployeePosition':
          commit('SET_EMPLOYEE_POSITION_DROPDOWN', response.data.data)
          break
        case 'EmployeePositionSubGroup':
          commit('SET_EMPLOYEE_POSITION_SUBGROUP_DROPDOWN', response.data.data)
          break
      }
    },
    async addAssignInventory({commit}, assign) {
      let response = await Api.request('post', '/hrInventoryAssign/saveEmployeeInventoryAssign/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId, assign)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async updateAssignInventory({commit}, sales) {
      let resp = await Api.request('put', '/hrInventoryAssign/updateInventoryAssign/' + sales.assignHeaderId + '/' + this.getters.userId, sales)
      commit('UPDATE_SALES', resp.data.data)
      return resp
    },
    async deleteAssignInventory({commit}, deleteRea) {
      let response = await Api.request('delete', '/hrInventoryAssign/updateInventoryAssign/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let employeeInventoryAssignList = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_EMPLOYEE_ASSIGN', employeeInventoryAssignList)
      }
      return response
    },
    async loadInventoryAssignList({commit}, dat) {
      let resp = await Api.request('get', '/hrInventoryAssign/inventoryAssignedEmployeeList/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + dat.fromDate + '/' + dat.toDate)
      commit('LOAD_EMPLOYEE_ASSIGN_LIST', resp.data.data)
      return resp
    },
    async loadInventoryAssignDetail({commit}, id) {
      let response = await Api.request('get', '/hrInventoryAssign/inventoryAssignedDetailsList/' + this.getters.organisationId + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('INVENTORY_ASSIGN_DETAIL', response.data.data)
      }
      return response
    },
    async addSalaryPosting({commit}, salary) {
      let response = await Api.request('post', '/hrSalaryPosting/saveBulkSalaryPosting/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.state.fyId + '/' + salary.month + '/' + salary.year, salary)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    // Employee Transfer API's
    async createEmployeeTransfer({commit}, employeeTransfer) {
      try {
        let response = await Api.request('post', '/hrEmployee/employeeTransfer/' + this.getters.organisationId + '/' + this.getters.userId, employeeTransfer)
        if (response.data.status === 'SUCCESS') {
          commit('ADD_EMPLOYEE_TRANSFER', response.data.data)
        }
        return response
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong', life: 3000})
      }
    },
    async updateEmployeeTransfer({commit}, employeeTransfer) {
      let response = await Api.request('get', '/hrEmployee/employeeTransfer/' + this.getters.organisationId, employeeTransfer)
      if (response.data.status === 'SUCCESS') {
        commit('EMPLOYEE_TRANSFER_LIST', response.data.data)
      }
      return response
    },
    async loadEmployeeTransfer({commit}) {
      let response = await Api.request('get', '/hrEmployee/employeeTransfer/' + this.getters.organisationId)
      if (response.data.status === 'SUCCESS') {
        commit('EMPLOYEE_TRANSFER_LIST', response.data.data)
      }
      return response
    },
    async loadEmployeeDataById({commit}, empId) {
      let response = await Api.request('get', '/hrEmployee/employeeTransfer/' + empId + '/' + this.getters.organisationId)
      return response
    }
  },
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store/humanResource.js